// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"71df535f","839":"7a02a524"}[chunkId] + ".chunk.js";
};